import MerchantHelpSupportPage from '../../../components/merchant/help-support/MerchantHelpSupportPage'

export default function HelpSupport() {
  return <MerchantHelpSupportPage />
}
